import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

const Avantages = () => {
  const { t } = useTranslation();
  const sectionRef = useRef(null);

  const renderIcon = (iconType) => {
    const iconProps = { width: "35", height: "35", fill: "#4CAF50" };
    
    switch(iconType) {
      case 'savings':
        return (
          <svg {...iconProps} viewBox="0 0 24 24">
            <path d="M7,15H9C9,16.08 10.37,17 12,17C13.63,17 15,16.08 15,15C15,13.9 13.96,13.5 11.76,12.97C9.64,12.44 7,11.78 7,9C7,7.21 8.47,5.69 10.5,5.18V3H13.5V5.18C15.53,5.69 17,7.21 17,9H15C15,7.92 13.63,7 12,7C10.37,7 9,7.92 9,9C9,10.1 10.04,10.5 12.24,11.03C14.36,11.56 17,12.22 17,15C17,16.79 15.53,18.31 13.5,18.82V21H10.5V18.82C8.47,18.31 7,16.79 7,15Z"/>
          </svg>
        );
      case 'support':
        return (
          <svg {...iconProps} viewBox="0 0 24 24">
            <path d="M12,1L3,5V11C3,16.55 6.84,21.74 12,23C17.16,21.74 21,16.55 21,11V5L12,1M12,7C13.4,7 14.8,8.6 14.8,10V11.5H16.3V10C16.3,7.9 14.1,5.5 12,5.5C9.9,5.5 7.7,7.9 7.7,10V11.5H9.2V10C9.2,8.6 10.6,7 12,7M8.5,13V19H15.5V13H8.5Z"/>
          </svg>
        );
      case 'communication':
        return (
          <svg {...iconProps} viewBox="0 0 24 24">
            <path d="M12,3C17.5,3 22,6.58 22,11C22,15.42 17.5,19 12,19C10.76,19 9.57,18.82 8.47,18.5C5.55,21 2,21 2,21C4.33,18.67 4.7,17.1 4.75,16.5C3.05,15.07 2,13.13 2,11C2,6.58 6.5,3 12,3Z"/>
          </svg>
        );
      case 'location':
        return (
          <svg {...iconProps} viewBox="0 0 24 24">
            <path d="M12,11.5A2.5,2.5 0 0,1 9.5,9A2.5,2.5 0 0,1 12,6.5A2.5,2.5 0 0,1 14.5,9A2.5,2.5 0 0,1 12,11.5M12,2A7,7 0 0,0 5,9C5,14.25 12,22 12,22C12,22 19,14.25 19,9A7,7 0 0,0 12,2Z"/>
          </svg>
        );
      default:
        return null;
    }
  };

  useEffect(() => {
    if (window.IntersectionObserver) {
      const observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          sectionRef.current.classList.add('visible');
          observer.disconnect();
        }
      }, { threshold: 0.2 });
      
      if (sectionRef.current) {
        observer.observe(sectionRef.current);
      }
      
      return () => observer.disconnect();
    }
  }, []);

  const avantages = [
    {
      icon: "savings",
      title: t('avantages.card1.title'),
      description: t('avantages.card1.description'),
      color: "#4CAF50"
    },
    {
      icon: "support",
      title: t('avantages.card2.title'),
      description: t('avantages.card2.description'),
      color: "#4CAF50"
    },
    {
      icon: "communication",
      title: t('avantages.card3.title'),
      description: t('avantages.card3.description'),
      color: "#FF6B35"
    },
    {
      icon: "location",
      title: t('avantages.card4.title'),
      description: t('avantages.card4.description'),
      color: "#9C27B0"
    }
  ];

  return (
    <section className="avantages section-animate" id="avantages" ref={sectionRef}>
      <div className="container">
        <div className="section-header">
          <h2 className="section-title title-animate">{t('avantages.title')}</h2>
          <p className="section-subtitle subtitle-animate">
            {t('avantages.subtitle')}
          </p>
        </div>
        
        <div className="avantages-grid">
          {avantages.map((avantage, index) => (
            <div key={index} className="avantage-card stagger-item card-premium focus-premium" style={{'--accent-color': avantage.color}} tabIndex="0">
              <div className="avantage-icon">
                {renderIcon(avantage.icon)}
              </div>
              <div className="avantage-content">
                <h3 className="avantage-title">{avantage.title}</h3>
                <p className="avantage-description">{avantage.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Avantages; 